import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initializeTheme } from '@shigo-ui/theme';

import '@shigo-ui/theme/tokens.css';
import '@shigo-ui/theme/reset.css';
import './styles.css';

import { App } from './App';
import { readShigoAppConfig } from './lib/config';
import { applyShigoDocumentMetadata } from './lib/documentMetadata';
import { dashboardT } from './lib/messages';
import { ShigoQueryProvider } from './lib/ShigoQueryProvider';

const root = document.getElementById('root');

applyShigoDocumentMetadata(readShigoAppConfig());
initializeTheme();

if (!root) {
  throw new Error(dashboardT('app.error.rootMissing'));
}

createRoot(root).render(
  <StrictMode>
    <ShigoQueryProvider>
      <App />
    </ShigoQueryProvider>
  </StrictMode>,
);
